import ApiClient from './apiClient'
import {
  RequestDeleteHolidaySchedule,
  RequestGetHolidayScheduleDetail,
  RequestPatchHolidaySchedule,
  RequestPostHolidaySchedule,
  ResponseGetHolidaySchedule,
  ResponseGetHolidayScheduleDetail,
  ResponsePostHolidaySchedule,
} from '../types/holidaySchedule'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getHolidaySchedule = async (): Promise<any> => ApiClient.get(
  '/api/setting/holiday_schedule',
  (result: ResponseGetHolidaySchedule) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getHolidayScheduleDetail = async (params: RequestGetHolidayScheduleDetail): Promise<any> => ApiClient.get(
  `/api/setting/holiday_schedule/${params.id}`,
  (result: ResponseGetHolidayScheduleDetail) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postHolidaySchedule = async (params: RequestPostHolidaySchedule): Promise<any> => ApiClient.post(
  '/api/setting/holiday_schedule',
  (result: ResponsePostHolidaySchedule) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchHolidaySchedule = async (params: RequestPatchHolidaySchedule): Promise<any> => ApiClient.patch(
  `/api/setting/holiday_schedule/${params.id}`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteHolidaySchedule = async (params: RequestDeleteHolidaySchedule): Promise<any> => ApiClient.delete(
  `/api/setting/holiday_schedule/${params.id}`,
  () => {
    // do nothing
  },
)
